import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { config } from "./config";
import Modal from "Pages/Common/CourseDetails/Demoform/demoForm";
import useStore from "store";
import { MdOutlineStarBorderPurple500 } from "react-icons/md";
import FloatingWhatsApp from "Reusable/FloatingWhatsApp";
import GuaranteePopup from "Reusable/GuaranteePopup/GuaranteePopup";

function Common() {
    const location = useLocation();
    const { SetDemoFormBeforeLogin, DemoFormBeforeLogin } = useStore(
        (item: any) => item
    );

    const minimalRoutes = ["/free-demo", "/book-demo", "/reading-assessment"];
    const isMinimalLayout = minimalRoutes.some(path => 
        location.pathname === path || 
        location.pathname === `${path}/` || 
        location.pathname.startsWith(`${path}/`)
    );

    return (
        <>
            {!isMinimalLayout && <FloatingWhatsApp />}
            {!isMinimalLayout && <GuaranteePopup />}
            {DemoFormBeforeLogin && <Modal dropDownProps={""} courseId={""} />}
            {!isMinimalLayout && (
                <div className="book-demo-right">
                    <button onClick={() => SetDemoFormBeforeLogin(true)}>
                        <span>Book Demo</span>
                        <p className="icon">
                            <MdOutlineStarBorderPurple500 size={18} />
                        </p>
                    </button>
                </div>
            )}
            <Routes>
                {config.map((route) => (
                    <Route
                        path={route.path}
                        element={<route.element />}></Route>
                ))}
            </Routes>
        </>
    );
}

export default Common;
